import React from 'react'
import Caixa from '../../ModulosCrefito/Caixa'
import HeaderVerde from '../../ModulosCrefito/HeaderVerde'
import Input from '../../ModulosCrefito/Input'
import Select from '../../ModulosCrefito/Select'

import { useSelector } from 'react-redux'

const AiTipo = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if (condicional[modulo]) var qtdFicha = condicional[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="AUTO DE INFRAÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Tipo da Infração" nome="tipoinfracao" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={[
                                "1 - Estágio não obrigatório do curso de Terapia Ocupacional em quantitativo acima do permitido na Resolução COFFITO 452/2015",
                                "2- Estágio obrigatório de acadêmicos(as) do curso de Terapia Ocupacional com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)",
                                "3- Exercício ilegal da profissão de terapeuta ocupacional.",
                                "4- Prática de atividades da Terapia Ocupacional por pessoa não habilitada.",
                                "5- Delegação de função privativa do profissional terapeuta ocupacional.",
                                "6- Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.",
                                "7- Ausência do responsável técnico de Terapia Ocupacional.",
                                "8- Profissional com Licença Temporária de Terapia Ocupacional vencida.",
                                "9- Falta de registro das atividades assistenciais terapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo terapeuta ocupacional, da guarda e do seu descarte. (Responsável Técnico)",
                                "10- Falta de registro de consultório.",
                                "11- Débitos com obrigações pecuniárias.",
                                "12- Descumprimento dos parâmetros assistenciais terapêuticos.(Responsável Técnico).",
                                "13- Descumprimento da Portaria CREFITO-1 Nº 046/2020.",
                                "14- Descumprimento da legislação referente ao registro em prontuário dos terapeutas ocupacionais.",
                                "15- Publicidade irregular - exposição de pacientes.",
                                "16- Publicidade irregular.",
                                "17- Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.",
                                "18- Profissional sem registro de inscrição secundária.",
                                "19- Desvio de circunscrição, pois o terapeuta ocupacional não realizou a transferência.",
                                "20- Falta de cadastro do estabelecimento fiscalizado de Terapia Ocupacional."
                            ]} />
                        {RenderTipo()}
                    </div>
                </Caixa>
            )

            function RenderTipo() {
                if (condicional[modulo][n]["tipoinfracao"] === "1 - Estágio não obrigatório do curso de Terapia Ocupacional em quantitativo acima do permitido na Resolução COFFITO 452/2015") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "2- Estágio obrigatório de acadêmicos(as) do curso de Terapia Ocupacional com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Local do estágio" nome="localestagio" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Instituição de Ensino" nome="instituicaoensino" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "3- Exercício ilegal da profissão de terapeuta ocupacional.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Estabelecimento" nome="estabelecimento" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CNPJ" nome="cnpj" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Leigo" nome="leigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="RG do Leigo" nome="rgleigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CPF do Leigo" nome="cpfleigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "4- Prática de atividades da Terapia Ocupacional por pessoa não habilitada.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="RG do Leigo" nome="rgleigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CPF do Leigo" nome="cpfleigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "5- Delegação de função privativa do profissional terapeuta ocupacional.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Leigo" nome="leigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="RG do Leigo" nome="rgleigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "6- Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome da Empresa" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CNPJ" nome="cnpj" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "7- Ausência do responsável técnico de Terapia Ocupacional.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Estabelecimento" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CNPJ" nome="cnpj" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "8- Profissional com Licença Temporária de Terapia Ocupacional vencida.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Vencimento do LTF" nome="vencimento" tipo="date" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "9- Falta de registro das atividades assistenciais terapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo terapeuta ocupacional, da guarda e do seu descarte. (Responsável Técnico)") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "10- Falta de registro de consultório.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "11- Débitos com obrigações pecuniárias.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Anuidades" nome="anuidades" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Multa Eleitoral" nome="multa" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Parcelamento das anuidades" nome="parcelamento" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "12- Descumprimento dos parâmetros assistenciais terapêuticos.(Responsável Técnico).") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "13- Descumprimento da Portaria CREFITO-1 Nº 046/2020.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "14- Descumprimento da legislação referente ao registro em prontuário dos terapeutas ocupacionais.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] ===  "15- Publicidade irregular - exposição de pacientes.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "16- Publicidade irregular.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Publicidade" nome="publicidade" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Endereço" nome="endereco" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CEP" nome="cep" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "17- Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CNPJ" nome="cnpj" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "18- Profissional sem registro de inscrição secundária.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Prazo para solicitar Inscrição" nome="prazo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "19- Desvio de circunscrição, pois o terapeuta ocupacional não realizou a transferência.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Número de Inscrição" nome="inscricao" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CREFITO antigo" nome="antigo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CREFITO novo" nome="novo" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
                else if (condicional[modulo][n]["tipoinfracao"] === "20- Falta de cadastro do estabelecimento fiscalizado de Terapia Ocupacional.") {
                    return (
                        <div>
                            <Input label="Número do A.I." nome="numeroai" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="Nome do Autuado" nome="autuado" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                            <Input label="CNPJ" nome="cnpj" modulo={modulo} index={n}
                                componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw" />
                        </div>
                    )
                }
            }
        }
        return partes
    }
}

export default AiTipo